import { call, put, takeEvery } from "redux-saga/effects";

import { PaginateQuery, ResponseGenerator } from "../../interfaces";
import {
  ADD_SUBJECT,
  AddSubjectAction,
  COPY_CUT_SUBJECT,
  CopyCutSubjectAction,
  DELETE_SUBJECT,
  DeleteSubjectAction,
  GET_PURCHASEABLE_SUBJECTS_FOR_STUDENT,
  GET_SUBJECT,
  GET_SUBJECTS,
  GET_SUBJECTS_BY_GRADE,
  GET_SUBJECT_LIST_BY_GRADE,
  GetPurchaseableSubjectForStudentAction,
  GetSubjectAction,
  GetSubjectSelectListByGradeAction,
  GetSubjectsAction,
  GetSubjectsByGradeAction,
  TOGGLE_SUBJECT_STATE,
  ToggleSubjectStateAction,
  UPDATE_SUBJECT,
  UPLOAD_SUBJECT_CONTENT_IMAGE,
  UPLOAD_SUBJECT_HOME_IMAGE,
  UpdateSubjectAction,
  UploadSubjectContentImageAction,
  UploadSubjectHomeImageAction,
} from "./actionTypes";

import {
  addSubject,
  deleteSubject,
  getSubject,
  getSubjects,
  getSubjectsByGrade,
  updateSubject,
  uploadSubjectContentImage,
  uploadSubjectHomeImage,
  copyCutSubject,
  toggleSubjectState,
  getSubjectsSelectListByGrade,
  getPurchaseableSubjectForStudent,
} from "../../helpers/backend_helper";
import {
  CopyCutSubjectSubjectError,
  CopyCutSubjectSubjectSuccess,
  addSubjectError,
  addSubjectSuccess,
  deleteSubjectError,
  deleteSubjectSuccess,
  getPurchaseableSubjectForStudentError,
  getPurchaseableSubjectForStudentSuccess,
  getSubjectError,
  getSubjectSelectListByGradeError,
  getSubjectSelectListByGradeSuccess,
  getSubjectSuccess,
  getSubjectsByGradeError,
  getSubjectsByGradeSuccess,
  getSubjectsError,
  getSubjectsSuccess,
  toggleSubjectStateError,
  toggleSubjectStateSuccess,
  updateSubjectError,
  updateSubjectSuccess,
  uploadSubjectContentImageError,
  uploadSubjectContentImageSuccess,
  uploadSubjectHomeImageError,
  uploadSubjectHomeImageSuccess,
} from "./actions";

function* getSubjectsSaga({
  payload: { request, history },
}: GetSubjectsAction) {
  try {
    const response: ResponseGenerator = yield call(
      getSubjects,
      request as PaginateQuery
    );
    yield put(getSubjectsSuccess(response.data));
  } catch (error) {
    yield put(getSubjectsError(error));
  }
}

function* getSubjectSaga({ payload: { id, history } }: GetSubjectAction) {
  try {
    const response: ResponseGenerator = yield call(getSubject, id);
    yield put(getSubjectSuccess(response.data));
  } catch (error) {
    yield put(getSubjectError(error));
  }
}

function* addSubjectSaga({ payload: { request, history } }: AddSubjectAction) {
  try {
    yield call(addSubject, request);
    yield put(addSubjectSuccess());
  } catch (error) {
    yield put(addSubjectError(error));
  }
}

function* updateSubjectSaga({
  payload: { id, request, history },
}: UpdateSubjectAction) {
  try {
    yield call(updateSubject, id, request);
    yield put(updateSubjectSuccess());
  } catch (error) {
    yield put(updateSubjectError(error));
  }
}

function* deleteSubjectSaga({ payload: { id, history } }: DeleteSubjectAction) {
  try {
    yield call(deleteSubject, id);
    yield put(deleteSubjectSuccess());
  } catch (error) {
    yield put(deleteSubjectError(error));
  }
}

function* getSubjectsByGradeSaga({
  payload: { gradeId },
}: GetSubjectsByGradeAction) {
  try {
    const response: ResponseGenerator = yield call(getSubjectsByGrade, gradeId);
    yield put(getSubjectsByGradeSuccess(response.data));
  } catch (error) {
    yield put(getSubjectsByGradeError(error));
  }
}

function* uploadSubjectHomeImageSaga({
  payload: { file, history, subjectId },
}: UploadSubjectHomeImageAction) {
  try {
    const response: ResponseGenerator = yield call(
      uploadSubjectHomeImage,
      file,
      subjectId
    );
    yield put(uploadSubjectHomeImageSuccess(response.data));
  } catch (error) {
    yield put(uploadSubjectHomeImageError(error));
  }
}

function* uploadSubjectContentImageSaga({
  payload: { file, history, subjectId },
}: UploadSubjectContentImageAction) {
  try {
    const response: ResponseGenerator = yield call(
      uploadSubjectContentImage,
      file,
      subjectId
    );
    yield put(uploadSubjectContentImageSuccess(response.data));
  } catch (error) {
    yield put(uploadSubjectContentImageError(error));
  }
}

function* copyCutSubjectSage({
  payload: { request, history },
}: CopyCutSubjectAction) {
  try {
    yield call(copyCutSubject, request);
    yield put(CopyCutSubjectSubjectSuccess());
  } catch (error) {
    yield put(CopyCutSubjectSubjectError(error));
  }
}

function* toggleSubjectStateSaga({
  payload: { id, history },
}: ToggleSubjectStateAction) {
  try {
    yield call(toggleSubjectState, id);
    yield put(toggleSubjectStateSuccess(id));
  } catch (error) {
    yield put(toggleSubjectStateError(error));
  }
}

function* getSubjectsSelectListByGradeSaga({
  payload: { gradeId },
}: GetSubjectSelectListByGradeAction) {
  try {
    const response: ResponseGenerator = yield call(
      getSubjectsSelectListByGrade,
      gradeId
    );
    yield put(getSubjectSelectListByGradeSuccess(response.data));
  } catch (error) {
    yield put(getSubjectSelectListByGradeError(error));
  }
}

function* getPurchaseableSubjectForStudentSaga({
  payload: { courseId, gradeId, userId },
}: GetPurchaseableSubjectForStudentAction) {
  try {
    const response: ResponseGenerator = yield call(
      getPurchaseableSubjectForStudent,
      courseId,
      gradeId,
      userId
    );
    yield put(getPurchaseableSubjectForStudentSuccess(response.data));
  } catch (error) {
    yield put(getPurchaseableSubjectForStudentError(error));
  }
}

function* SubjectSaga() {
  yield takeEvery(GET_SUBJECTS, getSubjectsSaga);
  yield takeEvery(GET_SUBJECT, getSubjectSaga);
  yield takeEvery(ADD_SUBJECT, addSubjectSaga);
  yield takeEvery(UPDATE_SUBJECT, updateSubjectSaga);
  yield takeEvery(DELETE_SUBJECT, deleteSubjectSaga);
  yield takeEvery(GET_SUBJECTS_BY_GRADE, getSubjectsByGradeSaga);
  yield takeEvery(UPLOAD_SUBJECT_HOME_IMAGE, uploadSubjectHomeImageSaga);
  yield takeEvery(UPLOAD_SUBJECT_CONTENT_IMAGE, uploadSubjectContentImageSaga);
  yield takeEvery(COPY_CUT_SUBJECT, copyCutSubjectSage);
  yield takeEvery(TOGGLE_SUBJECT_STATE, toggleSubjectStateSaga);
  yield takeEvery(GET_SUBJECT_LIST_BY_GRADE, getSubjectsSelectListByGradeSaga);
  yield takeEvery(
    GET_PURCHASEABLE_SUBJECTS_FOR_STUDENT,
    getPurchaseableSubjectForStudentSaga
  );
}

export default SubjectSaga;
